var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "generic-route h-v100" }, [
    _c(
      "div",
      {
        staticClass: "map-tab",
        class: {
          fullscreen: !(_vm.truckName || _vm.containerNum || _vm.gpsId),
        },
      },
      [
        _vm.truckName || _vm.containerNum || _vm.gpsId
          ? _c("div", { staticClass: "map-title" }, [
              _vm.truckName
                ? _c("span", { staticClass: "mr-3" }, [
                    _vm._v(
                      _vm._s(_vm.$t("planning.columns.plateNumber")) +
                        ": " +
                        _vm._s(_vm.truckName.toUpperCase())
                    ),
                  ])
                : _vm._e(),
              _vm.containerNum
                ? _c("span", { staticClass: "mr-3" }, [
                    _vm._v(
                      _vm._s(_vm.$t("planning.columns.containerNum")) +
                        ": " +
                        _vm._s(_vm.containerNum.toUpperCase())
                    ),
                  ])
                : _vm._e(),
              _vm.gpsId
                ? _c("span", { staticClass: "mr-3" }, [
                    _vm._v(
                      _vm._s(_vm.$t("planning.columns.gpsId")) +
                        ": " +
                        _vm._s(_vm.gpsId.toUpperCase())
                    ),
                  ])
                : _vm._e(),
            ])
          : _vm._e(),
        _vm.truckData.length >= 1
          ? _c("map-world", {
              ref: "mapWorld",
              attrs: {
                locations: _vm.locations,
                routes: _vm.truckData,
                "init-event": _vm.initEvent,
              },
            })
          : _vm._e(),
      ],
      1
    ),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }